import { useSnackbar } from 'notistack'
import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { OfflinePatient } from '@/core/offline'
import { useOfflineMode } from '@/providers/OfflineModeProvider'

export function useSyncPatient() {
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()
  const { isOfflineMode } = useOfflineMode()
  const isOnline = !isOfflineMode

  const [isSyncing, setIsSyncing] = useState(false)

  const syncPatient = useCallback(async (patient: OfflinePatient) => {
    if (!isOnline) return

    try {
      setIsSyncing(true)

      // TODO: Implement sync logic when sync service is ready
      // For now, just show a message
      enqueueSnackbar(t('Sync feature coming soon'), { variant: 'info' })
    } catch (error) {
      console.error('Error syncing patient:', error)
      enqueueSnackbar(t('Failed to sync patient'), { variant: 'error' })
    } finally {
      setIsSyncing(false)
    }
  }, [])

  return [syncPatient, isSyncing] as const
}
